import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListIcon, Squares4Icon } from 'assets/icons';
import { CarPartsViewMode } from 'domains/catalog/Catalog.types';
import { Flex, Icon, Segmented, SegmentedValue, Text } from 'UI';
import { SViewToggleWrapper } from './ViewToggle.styled';

interface ViewToggleProps {
  viewMode: CarPartsViewMode;
  onChange: (mode: CarPartsViewMode) => void;
}

const ViewToggle = ({ viewMode, onChange }: ViewToggleProps) => {
  const { t } = useTranslation();

  const options = [
    {
      value: 'VISUAL' as CarPartsViewMode,
      label: (
        <Flex direction={'row'} align={'center'} gap={7} padding={5}>
          <Icon IconComponent={Squares4Icon} size={14} display={'block'} />
          <Text type="base">{t('catalog.parts.category.car_parts.view.visual', 'Visual')}</Text>
        </Flex>
      ),
    },
    {
      value: 'LIST' as CarPartsViewMode,
      label: (
        <Flex direction={'row'} align={'center'} gap={7} padding={5}>
          <Icon IconComponent={ListIcon} size={14} display={'block'} />
          <Text type="base">{t('catalog.parts.category.car_parts.view.list', 'View List')}</Text>
        </Flex>
      ),
    },
  ];

  return (
    <SViewToggleWrapper>
      <Segmented
        value={viewMode}
        options={options}
        onChange={(val: SegmentedValue) => onChange(val as CarPartsViewMode)}
        data-cy={'car-parts-view-toggle'}
      />
    </SViewToggleWrapper>
  );
};

export default ViewToggle;
